<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="bgFotoMotorrad">
        <div class="overlayHotel">
          <div class="row justify-content-center align-items-center text-center">
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 center">
              <h3 class="Header__title px-5">
              {{  $t("Mit dem Motorrad durch den Thüringer Wald")}}
              </h3>
              <p class="Header__text">
              {{  $t("Fahren Sie mit dem Motorrad durch die malerische Landschaft")}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="kachelContainer">
          <div class="card mo1">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{ $t("Hotel") }}</h5>
            </div>
            <div class="card-footer2">
              {{ $t("Gemütliche Zimmer und erstklassiger Service für Ihren Aufenthalt") }}
            </div>
          </div>
          <div class="card mo2">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{ $t("Restaurant") }}</h5>
            </div>
            <div class="card-footer2">
              {{ $t("Regionale und internationale Küche in unserem stilvollen Restaurant") }}
            </div>
          </div>
          <div class="card mo3">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{ $t("Touren") }}</h5>
            </div>
            <div class="card-footer2">
              {{ $t("auf Wunsch geführte Touren mit dem Chef") }}
            </div>
          </div>
          <div class="card mo4">
            <div class="card-body kachel-body2">
              <h5 class="card-title">{{ $t("Service") }}</h5>
            </div>
            <div class="card-footer2">
              {{ $t("Schrauberecke mit Leihwerkzeug professionelle") }}
            </div>
          </div>
        </div>
      </section>
      <!-- Überschrift und Text -->
      <section>
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 text-center">
               <a href="https://www.tourenfahrer-hotels.de/hotel/deutschland/thueringer-wald/hotel-weinhaus-eberitzsch/detail/" target="_blank" rel="noopener">              
            <img
              src="../assets/tf-ph2.jpg"
              alt="Freies WLAN"
              class="img-fluid mx-auto d-block"
            />
            </a>
          </div>
        </div>
      </section>
      <section>
        <div class="row py-5 align-items-center justify-content-center">
          <div class="col-lg-8 align-items-center text-center">
            <h2 class="mb-4">{{ $t("Motorradabenteuer in Thüringen") }}</h2>
            <p>
              {{ $t("Genießen Sie das Komplettpaket: perfekter Ausgangspunkt für") }}
            </p>
            <h2 class="my-4 pt-5">{{ $t("Paketangebote") }}</h2>
            <p>
              <ul class="feiernUL">
                <li>{{ $t("2 oder 4 Übernachtungen in unserem gut ausgestattetem Hotel") }}</li>
                <li>{{ $t("2x bzw. 4x reichhaltiges Frühstücksbuffet") }}</li>
                <li>{{ $t("1x bzw. 3x Halbpension (3-Gänge-Menü)") }}</li>
                <li>
                  {{ $t("1x Grillabend – bei schönem Wetter in unserem gemütlichen Biergarten") }}
                </li>
                <li>
                  {{ $t("schrauberecke") }}
                </li>
                <li>
                  {{ $t("Zusätzliche Leistungen wie Verlängerungsnacht") }}
                </li>
              </ul>            
            </p>
            <p>
             {{ $t("WillkommeninunseremgemütlichenRestaurantText3") }}
              
            </p>
          </div>
        </div>
      </section>
      <section
        class="row justify-content-center align-items-center text-center pb-5"
      >
       
            <div class="col-12 col-lg-4">
              <h3 class="willkommen__title2 pt-5">{{ $t("Paketpreis 2 Tage") }}</h3>
              <h4>263,50 € {{ $t("pro Person") }}</h4>
              <p class="willkommen__text pt-3 pb-3">
                <br/>                
                {{ $t("Verlängerung")  }} 114,50 € 
              </p>
              <img
              src="../assets/c-5-2tagestour.jpg"
              alt="Freies WLAN"
              class="img-fluid mx-auto d-block"
            />
                <router-link to="#reservierung" class="btn-reservierung2">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
            </div>
             <div class="col-12 col-lg-4">
              <h3 class="willkommen__title2 pt-5">{{ $t("Paketpreis 4 Tage") }}</h3>
             <h4>233,50 € {{ $t("pro Person") }}</h4>
              <p class="willkommen__text pt-3 pb-3">
                
                {{ $t("Im DZ bei mindestens 2 Personen") }}<br/>
                {{ $t("Verlängerung")  }} 99,50 €{{ $t("proPersonNacht")  }}
              </p>  
              <img
              src="../assets/c-5-4tagestour.jpg"
              alt="Freies WLAN"
              class="img-fluid mx-auto d-block"
            />
                <router-link to="#reservierung" class="btn-reservierung2">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
        </div>        
      </section>
      <section>
        <div class="row justify-content-center">
        <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
          <h3 class="willkommen__title">{{ $t("Tourentipps für einen tollen Tag") }}</h3>
          <p class="willkommen__text">
            {{ $t("Entdecken Sie traumhafte Motorradstrecken mit vielen Kurven, die viel Spaß versprechen.") }}
          </p>

        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-lg-6">
            <div class="accordion" id="accordionPanelsStayOpenExample">
            <div class="accordion-item rundeEcken">
              <h2 class="accordion-header">
                <button class="accordion-button accordiumBG" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                  {{ $t("Kurvertour") }}
                </button>
              </h2>
              <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse show">
                <div class="accordion-body">
                   <p>{{ $t("Tour20") }}
                  
                  <br/>{{ $t("Tour21") }}
                   <br/>{{ $t("Tour22") }}
                  <br/>{{ $t("Tour23") }}
                  </p>
                  <p>           
                   {{ $t("Art: Tagestour") }}  <br/>
                    {{ $t("Start und Ziel: Bad Blankenburg (Hotel)") }} <br/>
                    {{ $t("Länge: ca. 300 km") }} <br/>
                    {{ $t("Fahrtzeit: ca. 5 Stunden") }}   <br/>
                  </p>
                </div>
              </div>
            </div>
 <div class="accordion-item rundeEcken">
              <h2 class="accordion-header">
                <button class="accordion-button accordiumBG" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                  {{ $t("Durch den kleinen und großen Thüringer Wald") }}
                </button>
              </h2>
              <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse ">
                <div class="accordion-body">
                  <p>{{ $t("Tour1") }}
                  
                  <br/>{{ $t("Tour2") }}
                   <br/>{{ $t("Tour3") }}
                  <br/>{{ $t("Tour4") }}
                  </p>
                  <p>           
                   {{ $t("Art: Tagestour") }}  <br/>
                    {{ $t("Start und Ziel: Bad Blankenburg (Hotel)") }} <br/>
                    {{ $t("Länge: ca. 300 km") }} <br/>
                    {{ $t("Fahrtzeit: ca. 5 Stunden") }}   <br/>
                  </p>
                </div>
              </div>
            </div>
           
            <div class="accordion-item rundeEcken">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed accordiumBG" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                  {{ $t("Thüringer Schiefergebirge und Thüringer Meer") }}                                                                                                     
                </button>
              </h2>
              <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <p>{{ $t("Tour5") }}
                    <br/>{{ $t("Tour6") }}
                    
                    <br/>{{ $t("Tour7") }}
                    
                  </p>
                  <p>
                   {{ $t("Art: Tagestour") }}  <br/>
                    {{ $t("Start und Ziel: Bad Blankenburg (Hotel)") }}  <br/>
                    {{ $t("Länge: ca. 350 km") }}  <br/>
                    {{ $t("Fahrtzeit: ca. 7 Stunden") }}</p>
                </div>
              </div>
            </div>
            <div class="accordion-item rundeEcken">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed accordiumBG" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                  Burgen- und Schlössertour
                </button>
              </h2>
              <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse">
                <div class="accordion-body">
                  <p>{{ $t("Tour8") }}
                    <br/>{{ $t("Tour9") }}
                    <br/>{{ $t("Tour10") }}
                    <br/>{{ $t("Tour11") }}
                    </p>
                    <p>
                    {{ $t("Art: Tagestour") }}  <br/>
                    {{ $t("Start und Ziel: Bad Blankenburg (Hotel)") }}  <br/>
                    {{ $t("Länge: ca. 250 km") }}  <br/>
                    {{ $t("Fahrtzeit: ca. 5 Stunden") }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>
      <secion>
        <div class="row justify-content-center pb-5">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 center">
            <h3 class="willkommen__title">{{ $t("Eindrücke von unseren Motorradtouren und der Umgebung") }}</h3>
            <p class="willkommen__text">
              
            </p>
            <KarussellMotorrad2 />
          </div>
        </div>
      </secion>
       <section id="reservierung">
        <div class="container-fluid pb-5" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="willkommen__title2 py-5 col-lg-6 d-flex flex-column align-items-center text-center">
              {{ $t("Reservierungsanfrage") }}
            </div>
          </div>
          <!-- Name -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Name*:") }}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  v-model="mail.name"
                      v-bind:class="background.name"
                />
              </div>
            </div>
          </div>
          <!-- Email -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Email*:") }}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Email"
                  v-model="mail.email"
                      v-bind:class="background.email"
                />
              </div>
              <p v-if="!isValidEmail && mail.email" class="text-danger">{{ $t("Ungültige E-Mail-Adresse") }}</p>
            </div>
          </div>
          <!-- Telefon -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Telefon:") }}</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Telefon"
                  v-model="mail.telefon"
                />
              </div>
            </div>
          </div>
          <!-- DAtum -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Vom:") }}*</span>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Vom"
                      v-bind:class="background.name"
                  v-model="mail.von"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Bis:") }}*</span>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Bis"
                      v-bind:class="background.name"
                  v-model="mail.bis"
                />
              </div>
            </div>
          </div>
<div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.zweitage" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("Zweitage  Komplettangebot") }}</span
                >
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.viertage" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1">{{ $t("Viertage Komplettangebot") }}</span>
              </div>
            </div>
          </div>
          <!-- Zimmer -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.doppelzimmer" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("DoppelzimmerAnzahl") }}</span
                >
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.einzelzimmer" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("EinzelzimmerAnzahl") }}</span
                >
              </div>
            </div>
          </div>
          
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.appartements" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("AppartementsAnzahl") }}</span
                >
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.verpflegung" class="form-select ">
                  <option value="0">{{ $t("Frühstück") }}</option>
                  <option value="1">{{ $t("Halbpension") }}</option>
                  <option value="2">{{ $t("Vollpension") }}</option>
                  <option value="3">{{ $t("ohne") }}</option>
                </select>
                <span class="input-group-text px-5" id="basic-addon1"
                  >{{ $t("Verpflegung") }}</span
                >
              </div>
            </div>
            
          </div>

          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="mb-3">
                <label for="exampleFormControlTextarea1" class="form-label"
                  >{{ $t("Nachricht:") }}</label
                >
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  v-model="mail.message"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center mb-5">
            <div class="col-12 col-lg-6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="mail.datenschutz"
                      v-bind:class="background.datenschutz"
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                 * {{ $t("Die Angaben zum") }}
                  <router-link to="/Datenschutz" class="">{{
                    $t("Datenschutz")
                  }}</router-link>
                  {{ $t("habe ich gelesen .") }}
                </label>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center mb-5">
            <div class="col-12 col-lg-6">
              <button type="button" class="btn btn-primary" @click="sendMail()">
                {{ $t("Anfragesenden") }}
              </button>
              </div>
          </div> 
          <div class="row">
            <div class="col-md-12">
              {{ mail.gesendet }}
            </div>
          </div>
        </div>
      </section>
      <!-- Gästeempfehlungen -->
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">{{ $t("Gästeempfehlenunsweiter") }}</h3>
            <h4 class="textcenter">
             “ {{ $t("Lage toll! Zimmer 1A.") }} ”
            </h4>
            </div>
        </div>
      </section>
    </div>
    <stickybarTelMail />
  </div>
  <stickyPfeil />
</template>

<script>
//import carouselHeader from "../components/carouselHeader.vue";
import axios from "axios";
import stickybarTelMail from "../components/stickybarTelMail.vue";
import stickyPfeil from "../components/stickyPfeil.vue";
import KarussellMotorrad2 from "@/components/KarussellMotorrad2.vue";

export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      newSite: null,
      mail: {
        name: "",
        email: "",
        message: "",
        telefon: "",
        doppelzimmer: 0,
        einzelzimmer: 0,
        zweitage: 0,
        viertage: 0,
        appartements: 0,
        verpflegung: 0,
        von: "",
        bis: "",
        datenschutz: false,
        gesendet: "",
      },
      background: {
        name: "",
        email: "",
        message: "",
        datenschutz: "",
        von: "",
        bis: "",

      },
    };
  },
  components: {
    stickybarTelMail,
    stickyPfeil,
    KarussellMotorrad2,
  },
  methods: {
checkEingaben() {
      let re = true;
      if (this.mail.name == "") {
        this.background.name = "border border-2 border-danger";
        re = false;
      } else {
        this.background.name = "border border-2 border-success";
      }
      if (this.mail.email == "") {
        this.background.email = "border border-2 border-danger";
        re = false;
      } else {
        this.background.email = "border border-2 border-success";
      }
      if (this.mail.von == "") {
        this.background.von = "border border-2 border-danger";
        re = false;
      } else {
        this.background.von = "border border-2 border-success";
      }
      if (this.mail.bis == "") {
        this.background.bis = "border border-2 border-danger";
        re = false;
      } else {
        this.background.bis = "border border-2 border-success";
      }
      if (this.mail.datenschutz == false) {
        this.background.datenschutz = "bg-danger";
        re = false;
      } else {
        this.background.datenschutz = "bg-success";
      }

      return re;
    },
    sendMail() {
      if (this.checkEingaben()) {
        const axiosConfig = {
          headers: {
            Accept: "text/plain",
            "Content-Type": "text/plain",
          },
        };
        const payload = {
          //empfaenger: "joerg@pillar.de",
          empfaenger: "info@weinhaus-eberitzsch.de",
          Name: this.mail.name,
          Email: this.mail.email,
          Telefon: this.mail.telefon,
          Text: this.mail.message,
          Doppelzimmer: this.mail.doppelzimmer,
          Einzelzimmer: this.mail.einzelzimmer,
          Familienzimmer: this.mail.familienzimmer,
          Hochzeitssuite: this.mail.hochzeitssuite,
          Appartements: this.mail.appartements,
          Von: this.mail.von,
          Bis: this.mail.bis,          

          Datenschutz: this.mail.datenschutz,
        };
        let mail = this.mail;
        let background = this.background;
        axios
          .post("https://pillar.de/mailrelay/post_attachment.php", payload, axiosConfig)
          .then((response) => {
            console.log("success", response.data);
            mail.gesendet = "Ihre Anfrage wurden erfolgreich versendet";
            mail.name = "";
            background.name = "";
            mail.email = "";
            background.email = "";
            mail.message = "";
            background.message = "";
            mail.datenschutz = false;
            background.datenschutz = "";
            mail.telefon = "";
            background.telefon = "";
            mail.doppelzimmer = 0;
            mail.einzelzimmer = 0;
            mail.familienzimmer = 0;
            mail.hochzeitssuite = 0;
            mail.appartements = 0;
            mail.von = "";
            mail.bis = "";

          })
          .catch((error) => {
            console.log(error.response);
            mail.gesendet =
              "Ihre Kontaktdaten konnten leider nicht gesendet werden. Bitte rufen Sie uns an.";
          });
      }
    },
    toggleDdown() {
      this.visi = true;
      setTimeout(() => (this.visi = false), 2000);
    },

  },
  computed: {
    isValidEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.mail.email);
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
    };
  },
};
</script>

<style scoped></style>
